/** Maximum length of a check name. */
export const MAX_NAME_LENGTH = 80;

/** Derives a snake_case id from a free-text name. */
export const slugifyId = (value: string): string =>
  value
    // Bound the input so slug generation stays linear regardless of the caller.
    .slice(0, MAX_NAME_LENGTH)
    .toLowerCase()
    .replaceAll(/[^a-z0-9]+/g, '_')
    .replaceAll(/_+/g, '_')
    .replace(/^[^a-z]+/, '')
    // Runs are already collapsed above, so only a single trailing underscore can
    // remain; matching without `+` avoids super-linear backtracking.
    .replace(/_$/, '');
